var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.65 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fa5a5a;}.cls-2{fill:#c14b50;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.33,70a6.68,6.68,0,0,1-4.75-2l-16-16A29.34,29.34,0,0,1,50,8.68a29.44,29.44,0,0,1,8.86,12.57A29.34,29.34,0,0,1,52.06,52l-16,16A6.62,6.62,0,0,1,31.33,70Zm0-53.88a14,14,0,1,0,14,14A14,14,0,0,0,31.33,16.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.32,4A27.31,27.31,0,0,1,50.65,50.62l-16,16a4.68,4.68,0,0,1-6.64,0l-16-16a27.31,27.31,0,0,1-6.34-28.7A27.18,27.18,0,0,1,31.32,4m0,42a16,16,0,1,0-16-16,16,16,0,0,0,16,16m0-46A31.31,31.31,0,0,0,9.17,53.45l16,16a8.7,8.7,0,0,0,12.31,0l16-16A31.29,31.29,0,0,0,31.32,0Zm0,42a12,12,0,1,1,12-12,12,12,0,0,1-12,12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.940a514d5aede41fab33c56400cde078.svg";
export { ForwardRef as ReactComponent };